import { toast } from 'react-toastify'
import { useDelete } from '../api'

import Swal from 'sweetalert2'
// import './styles.css'
const useDeleteMethod = () => {
  const deleteService = useDelete()

  const handleDelete = (
    serviceName: string,
    serviceId: string,
    service?: string,
    callback?: () => void,
  ) => {
    Swal.fire({
      title: `Are You sure you want to delete ${service}?`,
      showDenyButton: true,
      showCancelButton: false,
      confirmButtonText: 'Yes',
      denyButtonText: 'No',
      customClass: {
        actions: 'my-actions',
        cancelButton: 'order-1 right-gap',
        confirmButton: 'order-2',
        denyButton: 'order-3',
      },
    }).then((result) => {
      if (result.isConfirmed) {
        const loading = toast.loading(`Deleting`)
        deleteService.mutate(
          { serviceName, serviceId },
          {
            onSuccess: () => {
              Swal.fire('Deleted Successfully ', '', 'success')
              callback && callback()
            },
            onSettled: () => {
              toast.dismiss(loading)
            },
          },
        )
      }
      //   else if (result.isDenied) {
      //     Swal.fire('Changes are not saved', '', 'info')
      //   }
    })
  }

  return { handleDelete }
}

export default useDeleteMethod
